module.exports = ":root {\n  --page-padding: 16px;\n\n  --desktop-book-large-width: 1400px;\n  --desktop-book-medium-width: 1150px;\n  --desktop-book-small-width: 900px;\n  --desktop-book-width: var(--desktop-book-large-width);\n  --desktop-book-height-proportion: 0.625;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles